import { render } from "./BigMenu.vue?vue&type=template&id=8e341cae&scoped=true"
import script from "./BigMenu.vue?vue&type=script&lang=js"
export * from "./BigMenu.vue?vue&type=script&lang=js"

import "./BigMenu.vue?vue&type=style&index=0&id=8e341cae&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e341cae"]])

export default __exports__